export default __webpack_public_path__ + "static/codamx-audience-f84244875d4690013e08208c4ce3ecd4.jpg";